module.exports = __webpack_public_path__ + "img/14.76c08b2a.jpg";